import { Component } from "react";
import Rollbar from "rollbar";
import { auth } from "src/firebase/firebase.js";
export * from "./ErrorComponent.js";

const isStaging = window.location.hostname.includes("stanza-testing.com");

function checkWebComponentScript() {
  var scripts = document.getElementsByTagName("script");
  var scriptFound = false;
  for (var i = 0; i < scripts.length; i++) {
    var src = scripts[i].getAttribute("src");
    if (src && src.includes("timelineembedded.js")) {
      scriptFound = true;
      break;
    }
  }
  return scriptFound;
}

const isWebComponent = checkWebComponentScript();

export const rollbar = new Rollbar({
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  recorder: {
    enabled: true,
  },
  environment: isStaging ? "staging" : "production",
  // Rollbar is disabled in web component because it's capturing errors from the parent app
  enabled:
    (process.env.NODE_ENV === "production" || isStaging) && !isWebComponent,
  checkIgnore: function (isUncaught, args, payload) {
    // Check if this is a bot request
    const userAgent =
      typeof navigator !== "undefined" ? navigator.userAgent : "";
    const isBot = /bot|crawler|spider|crawling|PetalBot/i.test(userAgent);

    if (isBot) {
      return true; // discard bot errors
    }

    const message = payload.body?.trace?.exception?.message || "";
    const description = payload.body?.trace?.exception?.description || "";
    const filters = [
      "Object Not Found Matching Id",
      "Script error",
      "Connection to Indexed Database server lost. Refresh the page to try again",
    ];

    const frames = payload.body?.trace?.frames || [];
    const hasHotjarError = frames.some((frame) =>
      frame.filename?.includes("hotjar.com")
    );

    if (
      hasHotjarError ||
      filters.some(
        (filter) => message.includes(filter) || description.includes(filter)
      )
    ) {
      return true; // discard error
    }

    return false;
  },
});

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error(error);
    // Send error to parent window if app is embedded in iframe
    if (window.self !== window.top) {
      window.parent.postMessage(
        {
          type: "error",
          content: error.message,
          metadata: {
            source: "embedded-timeline-iframe",
            componentStack: errorInfo.componentStack,
          },
        },
        "*"
      );
    }
    const userSignedIn = Boolean(auth.currentUser);
    rollbar.error(error, errorInfo, { userSignedIn });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }

    return this.props.children;
  }
}
